import { IRequestContext } from '@msdyn365-commerce/core';

export const getFallbackImageSrc = (context: IRequestContext, manufacturerCode: string | undefined): string | undefined => {
    if (!manufacturerCode) {
        return undefined;
    }

    const mappings = context.app.config.defaultFallbackImage as { manufacturerCode: string; fallbackImage: { src: string } }[] | undefined;

    if (!mappings || mappings.length === 0) {
        return undefined;
    }

    const match = mappings.find(m => m.manufacturerCode === manufacturerCode);

    return match?.fallbackImage.src;
};

export const getManufacturerCode = (itemId?: string): string | undefined => {
    if (itemId && itemId.length >= 3) {
        return itemId.substring(0, 3).toUpperCase();
    }
    return undefined;
};
